module.exports = {"$schema":"https://vega.github.io/schema/vega/v3.json","width":950,"height":2500,"padding":5}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/global.json
// module id = ybhn
// module chunks = 0